import { render, staticRenderFns } from "./coreMetadata.vue?vue&type=template&id=0e99fa5b&scoped=true"
import script from "./coreMetadata.vue?vue&type=script&lang=js"
export * from "./coreMetadata.vue?vue&type=script&lang=js"
import style0 from "./coreMetadata.vue?vue&type=style&index=0&id=0e99fa5b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99fa5b",
  null
  
)

export default component.exports